/* eslint-disable no-prototype-builtins */
/* Utility functions for reducer composition
*  Mostly used to reduce boilerplate and increase readability
*  Reference: http://redux.js.org/docs/recipes/reducers/RefactoringReducersExample.html
*/

//Used to update state objects immutably
export const updateObject = (oldObject, newValues) => (
  {
    ...oldObject,
    ...newValues,
  }
);

//Let's us write reducers as a mapping from action type to handler
export const createReducer = (initialState, handlers) => (
  (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  }
);
